import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import FloatingCTA from "@/components/FloatingCTA";
import SEOHead from "@/components/SEOHead";
import POSTS, { PostCard } from "@/data/blogPosts";

export default function BlogIndex() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Blog",
    name: "Tribal Designz Blog",
    publisher: {
      "@type": "Organization",
      name: "Tribal Designz",
    },
    blogPost: POSTS.map((p) => ({
      "@type": "BlogPosting",
      headline: p.title,
      url: `https://tribaldesignz.com/blog/${p.slug}`,
    })),
  };

  return (
    <main className="bg-zinc-950 text-white min-h-screen">
      <SEOHead
        title="Tribal Designz Blog | Custom Uniforms NZ Insights"
        description="Guides on designing custom rugby uniforms, choosing print methods, and outfitting Auckland teams. Practical reads from a Pasifika & Māori-led apparel studio."
        path="/blog"
        jsonLd={jsonLd}
      />
      <Navbar />

      <section className="pt-28 md:pt-36 pb-12 border-b border-zinc-900">
        <div className="max-w-[1100px] mx-auto px-6 md:px-12">
          <p className="text-xs uppercase tracking-[0.3em] text-teal-400 font-semibold">
            The Studio Blog
          </p>
          <h1 className="mt-3 font-display uppercase text-4xl md:text-6xl lg:text-7xl tracking-tight leading-[0.95]">
            Custom uniforms, <br />
            culture &amp; <span className="text-teal-400">craft</span>
          </h1>
          <p className="mt-6 text-zinc-400 max-w-2xl text-lg leading-relaxed">
            Practical guides for Auckland clubs, schools and groups thinking
            about their next custom kit — written by the team that designs
            and makes them.
          </p>
        </div>
      </section>

      <section className="py-16 md:py-20">
        <div className="max-w-[1100px] mx-auto px-6 md:px-12 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {POSTS.map((p) => (
            <PostCard key={p.slug} post={p} />
          ))}
        </div>
      </section>

      <Footer />
      <FloatingCTA />
    </main>
  );
}
